import { TimeoutError } from 'rxjs'

export class EcoTimeoutError extends TimeoutError {}
